// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3WpiN","selects":"Documents_selects__HOc3m"};